import service from '@/plugins/service'

const base = 'auth/client'

export const searchClient = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addClient = data => {
  return service({
    url: base,
    method: 'POST',
    data
  })
}

export const updateClient = data => {
  return service({
    url: base,
    method: 'PUT',
    data
  })
}

export const getClientById = id => {
  return service({
    url: base,
    method: 'GET',
    params: {
      id
    }
  })
}

export const deleteClient = id => {
  return service({
    url: base,
    method: 'DELETE',
    params: {
      id
    }
  })
}